import { deleteAddress, deleteOccasion } from 'hooks/services/deleteService'
import { fetchAddress, fetchProfile, getEaterBenefits, getHowDidYouHearAboutUs, fetchOccasions } from 'hooks/services/fetchServices'
import {
  addAddress,
  addOccasion,
  postContactForm,
  resetCorpUserPassword,
  resetPasswordPost,
  updateProfile,
  uploadChefImg,
  uploadProfileImg
} from 'hooks/services/postService'
import { updateAddress, updateOccasion } from 'hooks/services/putService'
import Cookies from 'js-cookie'
import { toast } from 'react-toastify'
import { reportError } from 'utils/errorReporting'

export const FETCH_PROFILE_DATA_START = 'FETCH_PROFILE_DATA_START'
export const FETCH_PROFILE_DATA_SUCCESS = 'FETCH_PROFILE_DATA_SUCCESS'
export const FETCH_PROFILE_DATA_FAILURE = 'FETCH_PROFILE_DATA_FAILURE'
export function fetchProfileData() {
  return (dispatch) => {
    dispatch({
      type: FETCH_PROFILE_DATA_START,
      fetching: true
    })
    fetchProfile()
      .then((response) => {
        dispatch({ type: FETCH_PROFILE_DATA_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        dispatch({ type: FETCH_PROFILE_DATA_FAILURE, error, fetching: false })
      })
  }
}

export const UPDATE_PROFILE_DATA_START = 'UPDATE_PROFILE_DATA_START'
export const UPDATE_PROFILE_DATA_SUCCESS = 'UPDATE_PROFILE_DATA_SUCCESS'
export const UPDATE_PROFILE_DATA_FAILURE = 'UPDATE_PROFILE_DATA_FAILURE'
export function updateProfileData(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROFILE_DATA_START,
      fetching: true
    })
    updateProfile(data)
      .then((response) => {
        dispatch({ type: UPDATE_PROFILE_DATA_SUCCESS, response, fetching: false })
        dispatch(fetchProfileData())
        toast.success('Profile Updated Successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: UPDATE_PROFILE_DATA_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Profile Update Failed', { flow: 'update_profile' })
      })
  }
}

export const LOGIN_DATA = 'LOGIN_DATA'
export function loginData(response) {
  return (dispatch) => {
    dispatch({ type: LOGIN_DATA, data: response })
    dispatch(fetchProfileData())
  }
}

export const UPDATE_PROFILE_IMAGE_START = 'UPDATE_PROFILE_IMAGE_START'
export const UPDATE_PROFILE_IMAGE_SUCCESS = 'UPDATE_PROFILE_IMAGE_SUCCESS'
export const UPDATE_PROFILE_IMAGE_FAILURE = 'UPDATE_PROFILE_IMAGE_FAILURE'
export function updateProfileImage(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROFILE_IMAGE_START,
      fetching: true
    })
    uploadProfileImg(data)
      .then((response) => {
        dispatch({ type: UPDATE_PROFILE_IMAGE_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        const errors = error.response.data
        dispatch({ type: UPDATE_PROFILE_IMAGE_FAILURE, errors, fetching: false })
      })
  }
}

export function updateChefImage(data) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_PROFILE_IMAGE_START,
      fetching: true
    })
    uploadChefImg(data)
      .then((response) => {
        dispatch({ type: UPDATE_PROFILE_IMAGE_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        const errors = error.response.data
        dispatch({ type: UPDATE_PROFILE_IMAGE_FAILURE, errors, fetching: false })
      })
  }
}

export const FETCH_USER_ADDRESS_START = 'FETCH_USER_ADDRESS_START'
export const FETCH_USER_ADDRESS_FAILURE = 'FETCH_USER_ADDRESS_FAILURE'
export const FETCH_USER_ADDRESS_SUCCESS = 'FETCH_USER_ADDRESS_SUCCESS'
export function fetchUserAddress() {
  return (dispatch) => {
    dispatch({ type: FETCH_USER_ADDRESS_START, fetching: true })
    fetchAddress()
      .then((response) => {
        dispatch({ type: FETCH_USER_ADDRESS_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        const errors = error.response.data
        dispatch({ type: FETCH_USER_ADDRESS_FAILURE, errors, fetching: false })
      })
  }
}

export const DELETE_USER_ADDRESS_START = 'DELETE_USER_ADDRESS_START'
export const DELETE_USER_ADDRESS_FAILURE = 'DELETE_USER_ADDRESS_FAILURE'
export const DELETE_USER_ADDRESS_SUCCESS = 'DELETE_USER_ADDRESS_SUCCESS'
export function deleteUserAddress(id) {
  return (dispatch) => {
    dispatch({ type: DELETE_USER_ADDRESS_START, fetching: true })
    deleteAddress(id)
      .then((response) => {
        dispatch({ type: DELETE_USER_ADDRESS_SUCCESS, response, fetching: false })
        dispatch(fetchUserAddress())
        toast.success('Address deleted successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: DELETE_USER_ADDRESS_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Address not deleted', { flow: 'delete_address' })
      })
  }
}

export const UPDATE_USER_ADDRESS_START = 'UPDATE_USER_ADDRESS_START'
export const UPDATE_USER_ADDRESS_FAILURE = 'UPDATE_USER_ADDRESS_FAILURE'
export const UPDATE_USER_ADDRESS_SUCCESS = 'UPDATE_USER_ADDRESS_SUCCESS'
export function updateUserAddress(id, data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_USER_ADDRESS_START, fetching: true })
    updateAddress(id, data)
      .then((response) => {
        dispatch({ type: UPDATE_USER_ADDRESS_SUCCESS, response, fetching: false })
        dispatch(fetchUserAddress())
        toast.success('Address updated successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: UPDATE_USER_ADDRESS_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Address not updated', { flow: 'update_address' })
      })
  }
}

export const ADD_USER_ADDRESS_START = 'ADD_USER_ADDRESS_START'
export const ADD_USER_ADDRESS_FAILURE = 'ADD_USER_ADDRESS_FAILURE'
export const ADD_USER_ADDRESS_SUCCESS = 'ADD_USER_ADDRESS_SUCCESS'
export function addUserAddress(data) {
  return (dispatch) => {
    dispatch({ type: ADD_USER_ADDRESS_START, fetching: true })
    addAddress(data)
      .then((response) => {
        dispatch({ type: ADD_USER_ADDRESS_SUCCESS, response, fetching: false })
        toast.success('Address added successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: ADD_USER_ADDRESS_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Address not added', { flow: 'add_address' })
      })
  }
}

export const FETCH_EATER_BENEFITS_START = 'FETCH_EATER_BENEFITS_START'
export const FETCH_EATER_BENEFITS_SUCCESS = 'FETCH_EATER_BENEFITS_SUCCESS'
export const FETCH_EATER_BENEFITS_FAILURE = 'FETCH_EATER_BENEFITS_FAILURE'
export function fetchEaterBenefits() {
  return (dispatch) => {
    dispatch({ type: FETCH_EATER_BENEFITS_START, fetching: true })
    getEaterBenefits()
      .then((response) => {
        dispatch({ type: FETCH_EATER_BENEFITS_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        const errors = error.response.data
        dispatch({ type: FETCH_EATER_BENEFITS_FAILURE, errors, fetching: false })
      })
  }
}

export const REMOVE_PROFILE_DATA = 'REMOVE_PROFILE_DATA'
export function removeProfileData() {
  return (dispatch) => {
    dispatch({
      type: REMOVE_PROFILE_DATA
    })
  }
}

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START'
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'
export function resetPassword(data) {
  return (dispatch) => {
    dispatch({ type: RESET_PASSWORD_START })
    resetPasswordPost(data)
      .then((response) => {
        dispatch({ type: RESET_PASSWORD_SUCCESS, data: response })
        toast.success(response.message)
        if (response.detail) {
          toast.error(response.detail)
        }
        if (response.message) {
          setTimeout(() => {
            window.location.href = '/'
          }, 2000)
        }
      })
      .catch((error) => {
        dispatch({ type: RESET_PASSWORD_ERROR, data: error })
        reportError(error, error?.message || 'Password reset failed.', { flow: 'reset_password' })
      })
  }
}

export const RESET_CORP_USER_PASSWORD_START = 'RESET_CORP_USER_PASSWORD_START'
export const RESET_CORP_USER_PASSWORD_SUCCESS = 'RESET_CORP_USER_PASSWORD_SUCCESS'
export const RESET_CORP_USER_PASSWORD_ERROR = 'RESET_CORP_USER_PASSWORD_ERROR'
export function resetCorpUserPasswordAction(data) {
  return (dispatch) => {
    dispatch({ type: RESET_CORP_USER_PASSWORD_START })
    resetCorpUserPassword(data)
      .then((response) => {
        dispatch({ type: RESET_CORP_USER_PASSWORD_SUCCESS, data: response })
        toast.success(response.message)
        window.location.href = '/account'
        if (response.detail) {
          toast.error(response.detail)
        }
        if (response.message) {
          setTimeout(() => {
            window.location.href = '/'
          }, 2000)
        }
      })
      .catch((error) => {
        dispatch({ type: RESET_CORP_USER_PASSWORD_ERROR, data: error })
        reportError(error, error?.message || 'Password reset failed.', { flow: 'reset_corp_password' })
      })
  }
}

export const CONTACT_FORM_START = 'CONTACT_FORM_START'
export const CONTACT_FORM_SUCCESS = 'CONTACT_FORM_SUCCESS'
export const CONTACT_FORM_ERROR = 'CONTACT_FORM_ERROR'
export function sendContactFormData(data) {
  return (dispatch) => {
    dispatch({ type: CONTACT_FORM_START })
    postContactForm(data)
      .then((response) => {
        dispatch({ type: CONTACT_FORM_SUCCESS, data: response })
      })
      .catch((error) => {
        dispatch({ type: CONTACT_FORM_ERROR, error: error })
      })
  }
}

export const HEAR_ABOUT_US_SUCCESS = 'HEAR_ABOUT_US_SUCCESS'
export const HEAR_ABOUT_US_ERROR = 'HEAR_ABOUT_US_ERROR'
export function fetchHowDidYourHearAboutUs() {
  return (dispatch) => {
    getHowDidYouHearAboutUs()
      .then((response) => {
        dispatch({ type: HEAR_ABOUT_US_SUCCESS, data: response })
      })
      .catch((error) => {
        dispatch({ type: HEAR_ABOUT_US_ERROR, error: error })
      })
  }
}

export const LOGOUT_HANDLER = 'LOGOUT_HANDLER'
export function logoutStateHandle() {
  return (dispatch) => {
    dispatch({ type: LOGOUT_HANDLER })
    dispatch(removeProfileData())
    localStorage.removeItem('profile_data')
    localStorage.removeItem('dindin_key')
    Cookies.remove('authtoken')
  }
}


export const LANDING_PAGE = 'LANDING_PAGE'
export function landingPageAction(data) {
  return (dispatch) => {
    dispatch({ type: LANDING_PAGE, data })
  }
}

// Occasions
export const FETCH_OCCASIONS_START = 'FETCH_OCCASIONS_START'
export const FETCH_OCCASIONS_SUCCESS = 'FETCH_OCCASIONS_SUCCESS'
export const FETCH_OCCASIONS_FAILURE = 'FETCH_OCCASIONS_FAILURE'
export function fetchUserOccasions() {
  return (dispatch) => {
    dispatch({ type: FETCH_OCCASIONS_START, fetching: true })
    fetchOccasions()
      .then((response) => {
        dispatch({ type: FETCH_OCCASIONS_SUCCESS, response, fetching: false })
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: FETCH_OCCASIONS_FAILURE, errors, fetching: false })
      })
  }
}

export const ADD_OCCASION_START = 'ADD_OCCASION_START'
export const ADD_OCCASION_SUCCESS = 'ADD_OCCASION_SUCCESS'
export const ADD_OCCASION_FAILURE = 'ADD_OCCASION_FAILURE'
export function addUserOccasion(data) {
  return (dispatch) => {
    dispatch({ type: ADD_OCCASION_START, fetching: true })
    addOccasion(data)
      .then((response) => {
        dispatch({ type: ADD_OCCASION_SUCCESS, response, fetching: false })
        toast.success('Occasion added successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: ADD_OCCASION_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Occasion not added', { flow: 'add_occasion' })
      })
  }
}

export const UPDATE_OCCASION_START = 'UPDATE_OCCASION_START'
export const UPDATE_OCCASION_SUCCESS = 'UPDATE_OCCASION_SUCCESS'
export const UPDATE_OCCASION_FAILURE = 'UPDATE_OCCASION_FAILURE'
export function updateUserOccasion(id, data) {
  return (dispatch) => {
    dispatch({ type: UPDATE_OCCASION_START, fetching: true })
    updateOccasion(id, data)
      .then((response) => {
        dispatch({ type: UPDATE_OCCASION_SUCCESS, response, fetching: false })
        dispatch(fetchUserOccasions())
        toast.success('Occasion updated successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: UPDATE_OCCASION_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Occasion not updated', { flow: 'update_occasion' })
      })
  }
}

export const DELETE_OCCASION_START = 'DELETE_OCCASION_START'
export const DELETE_OCCASION_SUCCESS = 'DELETE_OCCASION_SUCCESS'
export const DELETE_OCCASION_FAILURE = 'DELETE_OCCASION_FAILURE'
export function deleteUserOccasion(id) {
  return (dispatch) => {
    dispatch({ type: DELETE_OCCASION_START, fetching: true })
    deleteOccasion(id)
      .then((response) => {
        dispatch({ type: DELETE_OCCASION_SUCCESS, response, fetching: false })
        dispatch(fetchUserOccasions())
        toast.success('Occasion deleted successfully')
      })
      .catch((error) => {
        const errors = error?.response?.data
        dispatch({ type: DELETE_OCCASION_FAILURE, errors, fetching: false })
        reportError(error, errors?.details || 'Occasion not deleted', { flow: 'delete_occasion' })
      })
  }
}
